import './list.scss';
import ListItem from '../list-item/list-item';

const List = ({ items, onRemove, onClick, badgeIds }) => {
	const sortedItems =
		items &&
		Object.values(items).sort(function (code1, code2) {
			if (code1?.putBadge && !code2?.putBadge) {
				return -1;
			} else if (!code1?.putBadge && code2?.putBadge) {
				return 1;
			}

			return 0;
		});

	return (
		<div className="list">
			{sortedItems?.map((item, index) => (
				<div className="list__item" key={item.code + index}>
					<ListItem item={item} onRemove={onRemove} onClick={onClick} hasBadges={badgeIds?.length > 0} />
				</div>
			))}
		</div>
	);
};

export default List;
